<template>
  <el-table ref='BaseTable' :data="list || []" tooltip-effect="light" v-loading="loading" v-bind="$attrs"
    v-on="$listeners" class="base-table" :class="{ report }" :span-method="isShowExpand ? arraySpanMethod : spanMethod"
    :element-loading-text="$t('common.loadingEllipsis')" element-loading-spinner="el-icon-loading" @expand-change="expandChange">
    <template v-for="(column, index) in columns">
      <slot name="front-slot"></slot>
      <!-- 序号 -->
      <el-table-column :key="index" v-if="column.type === 'selection'" type="selection" :width="column.width || 55"
        align="center"></el-table-column>
      <!-- 复选框 -->
      <el-table-column :key="index" v-else-if="column.type === 'index'" type="index" :width="column.width || 74"
        :label="column.title || $t('common.serialNumber')" :align="column.align || 'center'">
      </el-table-column>
      <!-- 具体内容 -->
      <el-table-column :key="index" v-else :align="column.align || 'center'"
        :show-overflow-tooltip="column.textOverFlow" :label="column.title" :min-width="column.width"
        :class-name="column.title === '操作' ? 'operationColumn' : ''">
        <template slot-scope="scope">
          <div class="cell-wrapper" :style="{ width: !column.textOverFlow ? (column.width - 20) + 'px' : 'auto' }"
            :class="{ left: column.align === 'left', right: column.align === 'right', 'text-overflow': column.textOverFlow }">
            <!-- 仅仅显示文字 -->
            <template v-if="!column.hidden">
              <!-- 如果hidden为true的时候 那么当前格可以不显示，可以选择显示自定义的slot-->
              <!-- 操作按钮 -->
              <template v-if="column.type === 'operate'">
                <a href="javascript:void(0)" class="operate-button"
                  v-for="(operate, operateIndex) in column.operates.filter(item => !item.hidden)"
                  :class="{ disabled: operate.disabledFilter && operate.disabledFilter(scope.row) }" :key="operateIndex"
                  @click="handleClick(operate, scope.row)">
                  {{ operate.transFilter ? operate.transFilter(scope.row[operate.key]) : operate.name }}
                  <template v-if="operate.emitKey === 'expand'">
                    <img v-if="!(operate.disabledFilter && operate.disabledFilter(scope.row))"
                      src="@/assets/i-toggle.png" class="i-toggle"
                      :class="{ up: expandedRows.some(item => item.id === scope.row.id) }" />
                    <img v-else src="@/assets/i-toggle-disabled.png" class="i-toggle disabled" />
                  </template>
                </a>
              </template>
              <template v-else-if="column.type === 'filter'">
                {{ column.filter[scope.row[column.key]] | emptyText }}
              </template>
              <template v-else-if="!column.textOverFlow || !column.width">{{ column.subKey ?
    scope.row[column.key][column.subKey] : scope.row[column.key] | emptyText }}</template>
              <label v-else>{{ column.subKey ? scope.row[column.key][column.subKey] : scope.row[column.key] | emptyText
                }}</label>
            </template>
            <!-- 使用slot的情况下 -->
            <template v-if="column.slot">
              <!-- 具名slot -->
              <slot :name="column.slot" :scope="scope"></slot>
            </template>
          </div>
        </template>
      </el-table-column>
    </template>
    <!-- 展开行 -->
    <el-table-column key="expand" v-if="isShowExpand" width="8" type="expand">
      <template slot-scope="scope">
        <div class="operate-button-wrapper expand-wrapper">
          <div :style="{ 'min-width': operateColumnWidth + 'px' }" class="operate-content-button-wrapper">
            <template v-if="operations.length">
              <a v-for="(operate, operateIndex) of operations" :key="operateIndex"
                :class="{ disabled: operate.disabledFilter && operate.disabledFilter(scope.row) }"
                href="javascript:void(0)" class="operate-button" @click="handleClick(operate, scope.row)">
                {{ operate.name }}
              </a>
            </template>
            <!-- 使用slot的情况下 -->
            <template v-if="expandSlot">
              <!-- 具名slot -->
              <slot name="expand" :row="scope.row"></slot>
            </template>
          </div>
        </div>
      </template>
    </el-table-column>
    <!--默认的slot -->
    <slot />
  </el-table>
</template>
<script>
import { searchAuthInPermission } from '@/utils/index'
export default {
  name: 'base-table',
  props: {
    list: { // 表格数据
      type: Array,
      default: function () {
        return []
      }
    },
    columns: { // headers列
      type: Array,
      required: true,
      default: function () {
        return []
      }
    },
    loading: { // loading状态
      type: Boolean,
      default: false
    },
    operations: { // 更多操作的按钮组
      type: Array,
      default: function () {
        return []
      }
    },
    operateable: { // 是否可以操作,为false则不显示操作按钮
      type: Boolean,
      default: true
    },
    spanMethod: {
      type: Function,
      default: function () {
        return () => { }
      }
    },
    report: { // 是否是报表的table
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      expandedRows: [], // 展开的行列表
      operateColumnWidth: 0 // 操作列的宽度
    }
  },
  computed: {
    btnPremissionEnum() { // 把按钮的权限数组做一次枚举，方便查找
      return this.$store.getters.btnsList.reduce((pre, next) => {
        pre[next] = true
        return pre
      }, {})
    },
    operationsFilterList() { // 如果操作按钮需要做权限过滤的话，对按钮集合进行预处理
      if (operations.some(item => item.authPath)) {
        return this.operations.reduce((pre, next) => {
          // if (this.btnPremissionEnum[next.authPath]) {
          if (searchAuthInPermission(next.authPath)) {
            pre.push(next)
          }
          return pre
        }, [])
      }
      return this.operations
    },
    expandSlot() { //是否存在展开行的slot
      return this.$scopedSlots.expand
    },
    isShowExpand() { //是否展示expand
      return this.operateable && (this.expandSlot || this.operations.length)
    }
  },
  watch: {
    list(listData) {
      if (listData && listData.length && this.expandedRows.length) {
        this.$nextTick(() => {
          this.expandedRows.map(item => {
            const row = listData.find(rowItem => rowItem.id === item.id)
            if (row) {
              this.$refs.BaseTable.toggleRowExpansion(row, false)
            }
          })
        })
      }
    }
  },
  updated() {
    if (this.isShowExpand) {
      this.$nextTick(() => {
        let target = window.document.getElementsByClassName('operationColumn')[0]
        const width = parseFloat(window.getComputedStyle(target, null).getPropertyValue('width'))
        this.operateColumnWidth = width
        target = null
      })
    }
  },
  methods: {
    handleClick({ emitKey }, data) {
      if (emitKey === 'expand') {
        return this.handleExpand(data)
      }
      this.$emit(`${emitKey}`, data)
    },
    select(selection, row) {
      this.$emit('select', selection, row)
    },
    selectAll(selection) {
      this.$emit('select-all', selection)
    },
    handleExpand(row) {
      this.$refs.BaseTable.toggleRowExpansion(row)
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === this.columns.length - 1) {
        return [1, 2];
      } else if (columnIndex === this.columns.length) {
        return [0, 0];
      }
    },
    expandChange(row, expandedRows) {
      this.expandedRows = expandedRows
    }
  }
}
</script>
<style lang="scss">
.base-table {
  .is-left .cell {
    padding-left: 16px !important;
  }

  .is-right .cell {
    padding-right: 16px !important;
  }

  .el-table__expanded-cell {
    padding: 14px 18px;
  }

  .operate-button-wrapper {
    display: flex;

    &:before {
      content: '';
      display: block;
      flex: 1;
    }

    .operate-content-button-wrapper {
      display: flex;
      justify-content: center;
      padding-left: 40px;
    }
  }

  .operate-button {
    font-size: 14px;
    line-height: 1;
    color: #0068b6;
    text-decoration: underline;
    display: inline-flex;
    align-items: center;
    padding-right: 6px;

    &:not(:only-child):not(:nth-last-of-type(1)) {
      border-right: 2px solid #bdbdc3;
      margin-right: 6px;
    }

    &:hover {
      color: #038AEF;
    }

    &.disabled {
      color: #BDBDC3;
      pointer-events: none;
    }
  }

  .expand-wrapper {
    .operate-button {
      &:not(:last-child)::after {
        top: 2px;
      }
    }
  }

  .text-overflow {
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: pointer;
    font-weight: normal;
  }

  .i-toggle {
    width: 16px;
    height: 11px;
    margin-left: 2px;
    transition: transform 200ms linear;
    transform: rotate(0deg);
    position: relative;
    top: 1px;

    &.up {
      transform: rotate(180deg);
    }

    &.disabled {
      width: 12px;
      height: 7px;
    }
  }

  .cell-wrapper {
    margin: 0 auto;

    &.left {
      margin-left: 0;
    }

    &.right {
      margin-right: 0;
    }
  }

  // 报表的合并列样式
  .group-title-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #333333;
    font-size: 14px;
  }

  .group-title-placeholder-text {
    display: block;
    padding: 4px 0;
    visibility: hidden;
  }

  .group-sum-title {
    white-space: nowrap;
    visibility: hidden;
  }

  .group-sum-placeholder-title {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 16px;
  }

  &.report {
    font-size: 12px;

    th.is-leaf {
      font-size: 12px;
    }

    td {
      padding: 5px 0;
    }
  }
}
</style>
